module.exports = __webpack_public_path__ + "media/images/360/about-8fbac4473227ca18c69e13263faffcd7.webp";